var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.checkedIn
    ? _c(
        "button",
        {
          staticClass: "btn btn-sm btn-success",
          attrs: {
            disabled: _vm.saving,
            title: _vm.$t("visitorManagement.presence.tooltip.checkIn")
          },
          on: { click: _vm.startPresence }
        },
        [
          _vm.saving
            ? _c("Spinner", { attrs: { small: true } })
            : _c("i", { staticClass: "fa fa-play" })
        ],
        1
      )
    : _c(
        "button",
        {
          staticClass: "btn btn-sm btn-danger",
          attrs: {
            disabled: _vm.saving,
            title: _vm.$t("visitorManagement.presence.tooltip.checkOut")
          },
          on: { click: _vm.stopPresence }
        },
        [
          _vm.saving
            ? _c("Spinner", { attrs: { small: true } })
            : _c("i", { staticClass: "fa fa-stop" })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }